import {
  MOBILE_REGEX_HK,
  MOBILE_REGEX_CN,
  MOBILE_REGEX_MO,
  ID_REGEX_CN,
  ID_REGEX_HK,
  ID_REGEX_MO,
  PASSPORT_REGEX,
} from './regex'
import { formatDialingCode } from './index'
import translationHK from 'src/assets/locales/zh-HK/translation.json'
export const PROMOTION_CODE = 'NEW330'
export const HEADER_HEIGHT = 15
export const MOBILE_HEADER_HEIGHT = 8
export const FOOTER_HEIGHT = 70
export const LABEL_WIDTH = 20
export const MOBILE_LABEL_WIDTH = 12
export const INPUT_WIDTH = 30
export const MOBILE_INPUT_WIDTH = 25.375
// 订单过期时间
export const PAY_EXPIRED_TIME = 2 * 60 * 60 * 1000
// 验证码倒计时
export const GET_CODE_EXPIRED_TIME = 2 * 60 * 1000
export const AVAILABLE_MONTHS = 2
export const LATER_DISABLE_DAYS = 3
export const SERVICE_CHARGE_RATE = 0.035
export const SERVICE_PHONE = formatDialingCode('852') + '3613 0533'
export const SERVICE_PHONE_02 = formatDialingCode('852') + '3613 0536'
export const SERVICE_EMAIL = 'info@take2.health'
export const SERVICE_EMAIL_02 = 'customer.support@take2.health'
export const SERVICE_WHATSAPP = formatDialingCode('852') + '5377 0823'
export const DATE_FORMAT = 'yyyy-MM-dd'
export const DATE_FORMAT_WITHOUT_CONNECT = 'yyyyMMdd'
export const BIRTHDAY_FORMAT = 'yyyy/MM/dd'
export const OLD_BIRTHDAY_FORMAT = 'MM.dd.yyyy'
export const DAY_OF_WEEK = 'eeee'
export const DATE_FORMAT_WITH_WEEK = `yyyy-MM-dd(${DAY_OF_WEEK})`
export const DATE_FORMAT_WITH_TIME = 'yyyy-MM-dd HH:mm'
export const DATABASE_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const DATABASE_DATE_TIMEZONE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ssXXXX'
export const TIMEZONE = '+0800'
export const TIME_SLICE = 'HH:mm'
export const WEEK_LIST = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export const CUSTOM_BREAKPOINTS = {
  md: 960,
}

export const DIALING_CODES = [
  {
    label: 'form.phone_type_list.0',
    value: '852',
    regex: MOBILE_REGEX_HK,
  },
  {
    label: 'form.phone_type_list.1',
    value: '086',
    regex: MOBILE_REGEX_CN,
  },
  {
    label: 'form.phone_type_list.2',
    value: '853',
    regex: MOBILE_REGEX_MO,
  },
]
export const ID_TYPES = [
  {
    label: 'form.id_type_list.0',
    value: 0,
    regex: ID_REGEX_CN,
  },
  {
    label: 'form.id_type_list.1',
    value: 1,
    regex: ID_REGEX_HK,
  },
  {
    label: 'form.id_type_list.2',
    value: 2,
    regex: ID_REGEX_MO,
  },
  {
    label: 'form.id_type_list.3',
    value: 3,
    regex: PASSPORT_REGEX,
  },
]

export const PACKAGE_INFO = {
  1: {
    title: 'glossary.prophecy',
    color: 'rgb(235, 124, 0)',
    id: 'EH_ProductInfo_Prophecy_InfoCard',
    detailsId: 'EH_Doctor_Prophecy_Item__Details',
    path: '/product-prophecy',
    index: 0,
  },
  2: {
    title: 'form.cancer',
    color: 'secondary.main',
    id: 'EH_ProductInfo_CancerScreening_InfoCard',
    detailsId: 'EH_Doctor_CancerMarker_Item_Details',
    path: '/product-cancer-screening',
    index: 1,
  },
  3: {
    index: 4,
    title: 'form.physical_examination_basic',
    color: 'rgb(65, 136, 158)',
    id: 'EH_ProductInfo_Prophecy_InfoCard_All',
    detailsId: 'EH_Doctor_StandardHealthCheck_Item_Details',
    path: '/product-standard-health-check-package',
  },
  4: {
    index: 3,
    title: 'form.physical_examination_man',
    color: 'primary.main',
    id: 'EH_ProductInfo_Prophecy_InfoCard_Male',
    detailsId: 'EH_Doctor_ComprehensiveHealthCheck_M_Item_Details',
    path: '/product-male-health-check-package',
  },
  5: {
    index: 2,
    title: 'form.physical_examination_women',
    color: 'primary.main',
    id: 'EH_ProductInfo_Prophecy_InfoCard_Female',
    detailsId: 'EH_Doctor_ComprehensiveHealthCheck_F_Item_Details',
    path: '/product-female-health-check-package',
  },
}
export const LOCATIONS = [
  { label: '全部地區', value: '' },
  { label: '香港島東', value: '香港島東' },
  { label: '香港島西', value: '香港島西' },
  { label: '九龍東', value: '九龍東' },
  { label: '九龍西', value: '九龍西' },
  { label: '九龍中', value: '九龍中' },
  { label: '新界東南', value: '新界東南' },
  { label: '新界北', value: '新界北' },
  { label: '新界東北', value: '新界東北' },
  { label: '新界西北', value: '新界西北' },
  { label: '新界西南', value: '新界西南' },
  { label: '離島區', value: '離島區' },
]

export const REGIONS = {
  全部地區: 'common:options.regions.all',
  香港: 'common:options.regions.hongkong',
  澳門: 'common:options.regions.macao',
  九龍西: 'common:options.regions.kowloon_west',
  九龍中: 'common:options.regions.kowloon_central',
  九龍東: 'common:options.regions.kowloon_east',
  香港島西: 'common:options.regions.west_of_hongkong_island',
  香港島東: 'common:options.regions.east_of_hongkong_island',
  新界北: 'common:options.regions.new_territories_north',
  新界東南: 'common:options.regions.southeast_new_territories',
  新界西北: 'common:options.regions.northwest_new_territories',
  新界東北: 'common:options.regions.northeast_new_territories',
  新界西南: 'common:options.regions.southwest_new_territories',
  其他地區: 'common:options.regions.other',
  離島區: 'common:options.regions.Islands',
}

/**
 * 1.Extra Care Privacy Policy
 * 2.Extra Care 会员 T&C
 * 3.Platform 个人资料收集声明
 * 4.会员条款及细则
 * 5.私隐政策
 * 6.个人资料收集证明
 * 其中123是注册时必须勾选的，456是希望显示在网页最底部的
 */

export const AGREEMENT_ID_MAP = {
  // Extra Care Privacy Policy
  extraCarePrivacyPolicy: {
    id: 5,
    label: 'glossary.policy_and_agreement_list.7',
  },
  // Extra Care 会员 T&C
  extraCareClub: {
    id: 4,
    label: 'glossary.policy_and_agreement_list.8',
  },
  // Platform 个人资料收集声明
  platformPersonalInfoCollectPolicy: {
    id: 14,
    label: 'glossary.policy_and_agreement_list.2',
  },
  // 会员条款及细则
  clubPolicy: {
    id: 3,
    label: 'glossary.policy_and_agreement_list.3',
  },
  // 私隐政策
  privacyPolicy: {
    id: 2,
    label: 'glossary.policy_and_agreement_list.4',
  },
  // 个人资料收集证明
  personalInfoCollectProve: {
    id: 1,
    label: 'glossary.policy_and_agreement_list.5',
  },
  orderAgreement: {
    id: 6,
    label: 'glossary.policy_and_agreement_list.6',
  },
}

export const SITE_MATE_DATA = {
  WHATSAPP:
    'https://api.whatsapp.com/send/?phone=85253770823&text=Hello%2C+I+want+to+know+more+about+Prophecy+Test%21+&app_absent=0',
  FACEBOOK: 'https://www.facebook.com/take2health.ltd',
  LINKEDIN: 'https://www.linkedin.com/company/take2-health',
  YOUTUBE: 'https://youtu.be/BACVA3es0NI',
  PORTAL: process.env.REACT_APP_URL,
  CAMPAIGN_PAGE: '/whats-new/campaign/',
  EARLY_CANCER_DETECTION: '/our-technologies/early-cancer-detection/',
  WHATSAPP_UPDATE_HK:
    'https://api.whatsapp.com/send/?phone=85253770823&text=%E4%BD%A0%E5%A5%BD%2C+%E6%88%91%E6%83%B3%E6%9B%B4%E6%94%B9%E9%A0%90%E7%B4%84%21+&app_absent=0',
  WHATSAPP_UPDATE_EN:
    'https://api.whatsapp.com/send/?phone=85253770823&text=Hello%2C+I+would+like+to+change+my+appointment%21+&app_absent=0',
  WHATSAPP_UPDATE_CN:
    'https://api.whatsapp.com/send/?phone=85253770823&text=%E6%82%A8%E5%A5%BD%2C+%E6%88%91%E6%83%B3%E6%9B%B4%E6%94%B9%E9%A2%84%E7%BA%A6%21+&app_absent=0',
  WHATSAPP_HELP_HK:
    'https://api.whatsapp.com/send/?phone=85253770823&text=%E4%BD%A0%E5%A5%BD%2C+%E6%88%91%E6%83%B3%E8%81%AF%E7%B5%A1%E5%AE%A2%E6%88%B6%E6%9C%8D%E5%8B%99%E4%B8%BB%E4%BB%BB%21+&app_absent=0',
  WHATSAPP_HELP_CN:
    'https://api.whatsapp.com/send/?phone=85253770823&text=%E6%82%A8%E5%A5%BD%2C+%E6%88%91%E6%83%B3%E8%81%94%E7%BB%9C%E5%AE%A2%E6%9C%8D%21+&app_absent=0',
  WHATSAPP_HELP_EN:
    'https://api.whatsapp.com/send/?phone=85253770823&text=Hello%2C+I+would+like+to+contact+customer+service+officer%21+&app_absent=0',
  WHATSAPP_PC_CN:
    'https://api.whatsapp.com/send/?phone=85253770823&text=%E6%82%A8%E5%A5%BD%2C+%E6%88%91%E6%83%B3%E4%BA%86%E8%A7%A3%E6%9C%89%E5%85%B3Prophecy%E7%9A%84%E8%B5%84%E8%AE%AF%21+&app_absent=0',
  WHATSAPP_PC_EN:
    'https://api.whatsapp.com/send/?phone=85253770823&text=Hello%2C+I+want+to+know+more+about+Prophecy+Test%21+&app_absent=0',
  WHATSAPP_PC_HK:
    'https://api.whatsapp.com/send/?phone=85253770823&text=%E4%BD%A0%E5%A5%BD%2C+%E6%88%91%E6%83%B3%E4%BA%86%E8%A7%A3%E6%9B%B4%E5%A4%9A%E6%9C%89%E9%97%9CProphecy%E7%9A%84%E8%B3%87%E8%A8%8A%21+&app_absent=0',
}

export const ORDER_STATUS = {
  PENDING_PAYMENT: 0, // 待支付，刚创建订单
  PAID: 1, // 已支付
  EXPIRED: 2, // 已失效
  PENDING_REFUND: 3, // 待退款（web端申请退款后状态，admin端叫待审核）
  REFUNDED: 4, // 已退款
  CANCELLED: 5, // 订单已取消
  APPROVAL_FAILED: 6, // 审核失败
  APPROVAL_SUCCEED: 7, // 审核成功
  REFUND_FAILED: 8, // 退款失败
}
export const PROMOTION_INNER = {
  url: '/whats-new/promotions/take2-rewards',
}
export const productCardData = [
  {
    // img: tImage('Prophecy_3x2', 'webp'),
    img: 'Prophecy_3x2',
    name: 'glossary.prophecy',
    nameInclude: false,
    intro: 'productPage.NPC.first_website_card_intro.2',
    price: 'HKD2,200',
    path: '/product-prophecy',
    promotion: 'form.health_check.promotion',
    id: 'EH_ProductInfo_Prophecy_InfoCard',
    detail: 'productPage.NPC_intro',
    package: '1',
    discountprice: 330,
    imgmobile: 'Prophecy',
    nameHK: translationHK?.glossary.prophecy,
    index: 0,
  },
  {
    // img: tImage('product_NPC', 'webp'),
    img: 'cancer_3x2',
    name: 'form.cancer',
    nameInclude: true,
    intro: 'productPage.NPC.first_website_card_intro.1',
    price: 'HKD3,500',
    path: '/product-cancer-screening',
    promotion: 'form.health_check.promotion',

    id: 'EH_ProductInfo_CancerScreening_InfoCard',
    detail: 'productPage.intro',
    package: '2',
    discountprice: 330,
    imgmobile: 'cancer',
    nameHK: translationHK?.form.cancer,
    index: 1,
  },
  {
    // img: tImage('product_NPC', 'webp'),
    img: 'health_check_female_3x2',
    name: 'glossary.physical_examination_female',
    nameInclude: true,
    intro: 'productPage.NPC.first_website_card_intro.1',
    price: 'HKD4,300',
    path: '/product-female-health-check-package',
    promotion: 'form.health_check.promotion',
    detail: 'productPage.health_check.intro',
    id: 'EH_ProductInfo_Prophecy_InfoCard_Female',
    package: '5',
    discountprice: 330,
    imgmobile: 'health_check_female',
    nameHK: translationHK?.glossary.physical_examination_female,
    index: 2,
  },
  {
    // img: tImage('product_NPC', 'webp'),
    img: 'health_check_male_3x2',
    name: 'glossary.physical_examination_male',
    nameInclude: true,
    intro: 'productPage.NPC.first_website_card_intro.1',
    price: 'HKD4,300',
    path: '/product-male-health-check-package',
    promotion: 'form.health_check.promotion',
    detail: 'productPage.health_check.intro',
    id: 'EH_ProductInfo_Prophecy_InfoCard_Male',
    package: '4',
    discountprice: 330,
    imgmobile: 'health_check_male',
    nameHK: translationHK?.glossary.physical_examination_male,
    index: 3,
  },
  {
    // img: tImage('product_NPC', 'webp'),
    img: 'health_check_3x2',
    name: 'form.physical_examination_basic',
    nameInclude: true,
    intro: 'productPage.NPC.first_website_card_intro.1',
    path: '/product-standard-health-check-package',
    price: 'HKD4,000',
    promotion: 'form.health_check.promotion',
    detail: 'productPage.health_check.intro',
    id: 'EH_ProductInfo_Prophecy_InfoCard_All',
    package: '3',
    discountprice: 330,
    imgmobile: 'health_check',
    nameHK: translationHK?.form.physical_examination_basic,
    index: 4,
  },
]
